import React from "react";

// Billetes y monedas MXN clicables para el modal de cobro.
// Para usar imagenes reales en vez del SVG generado, agrega `img: "<url>"` a la denominacion.
export const COINS = [
  { value: 1, label: "$1", ring: "#c9ccd1", center: "#d9a441", center2: "#f2cf7e" },
  { value: 2, label: "$2", ring: "#c9ccd1", center: "#d9a441", center2: "#f2cf7e" },
  { value: 5, label: "$5", ring: "#c9ccd1", center: "#d9a441", center2: "#f2cf7e" },
  { value: 10, label: "$10", ring: "#d9a441", center: "#c9ccd1", center2: "#e9ebee" },
];

export const BILLS = [
  { value: 20, label: "$20", a: "#3a4a9f", b: "#6a7bd6" },
  { value: 50, label: "$50", a: "#b23a7a", b: "#e07fb0" },
  { value: 100, label: "$100", a: "#c23b2b", b: "#e77a5a" },
  { value: 200, label: "$200", a: "#2f8f4e", b: "#7fd39a" },
  { value: 500, label: "$500", a: "#d9722b", b: "#f2b06a" },
  { value: 1000, label: "$1000", a: "#7a3ba0", b: "#c08ae0" },
];

function BillSvg({ b }) {
  const g = `bg${b.value}`;
  const p = `bp${b.value}`;
  const c = `bc${b.value}`;
  return (
    <svg viewBox="0 0 220 110" xmlns="http://www.w3.org/2000/svg" className="cash-svg">
      <defs>
        <linearGradient id={g} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={b.b} />
          <stop offset="100%" stopColor={b.a} />
        </linearGradient>
        <pattern id={p} width="18" height="18" patternUnits="userSpaceOnUse" patternTransform="rotate(20)">
          <circle cx="4" cy="4" r="1.3" fill="#fff" opacity="0.18" />
          <circle cx="13" cy="10" r="1.3" fill="#fff" opacity="0.14" />
          <path d="M0 14 Q9 8 18 14" stroke="#fff" strokeWidth="0.6" fill="none" opacity="0.12" />
        </pattern>
        <clipPath id={c}><rect x="3" y="3" width="214" height="104" rx="10" /></clipPath>
      </defs>
      <rect x="3" y="3" width="214" height="104" rx="10" fill={`url(#${g})`} stroke="#00000022" strokeWidth="1.5" />
      <rect x="3" y="3" width="214" height="104" rx="10" fill={`url(#${p})`} />
      <g clipPath={`url(#${c})`}>
        <rect x="150" y="3" width="10" height="104" fill="#fff" opacity="0.25" />
        <rect className="cash-shine" x="-40" y="-20" width="40" height="150" fill="#fff" opacity="0.35" />
      </g>
      <rect x="8" y="8" width="204" height="94" rx="6" fill="none" stroke="#fff" strokeOpacity="0.5" strokeWidth="1" />
      <text x="18" y="36" fontFamily="Georgia, serif" fontSize="24" fontWeight="bold" fill="#fff">{b.label}</text>
      <text x="18" y="94" fontFamily="Georgia, serif" fontSize="12" fill="#fff" opacity="0.85">PESOS · MX</text>
      <g transform="translate(150,55)" opacity="0.9">
        <polygon points="0,-16 14,-5 9,13 -9,13 -14,-5" fill="none" stroke="#fff" strokeWidth="1.4" opacity="0.6" />
        <circle r="4" fill="#fff" opacity="0.7" />
      </g>
    </svg>
  );
}

function CoinSvg({ c }) {
  const r = `cr${c.value}`;
  const m = `cm${c.value}`;
  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg" className="cash-svg">
      <defs>
        <radialGradient id={r} cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor="#fff" />
          <stop offset="55%" stopColor={c.ring} />
          <stop offset="100%" stopColor="#9a9da3" />
        </radialGradient>
        <radialGradient id={m} cx="35%" cy="30%" r="75%">
          <stop offset="0%" stopColor={c.center2} />
          <stop offset="100%" stopColor={c.center} />
        </radialGradient>
      </defs>
      <circle cx="80" cy="80" r="74" fill={`url(#${r})`} stroke="#7d7f85" strokeWidth="1.5" />
      <circle cx="80" cy="80" r="50" fill={`url(#${m})`} stroke="#00000022" strokeWidth="1.2" />
      <ellipse cx="60" cy="55" rx="26" ry="14" fill="#fff" opacity="0.3" />
      <text x="80" y="93" textAnchor="middle" fontFamily="Georgia, serif" fontSize="32" fontWeight="bold" fill="#3a2c10">{c.label}</text>
    </svg>
  );
}

function Piece({ item, kind, count, onPick }) {
  return (
    <button type="button" className={`cash-piece cash-piece--${kind}`} onClick={() => onPick(item.value)} title={`Sumar ${item.label}`}>
      {item.img
        ? <img src={item.img} alt={item.label} className="cash-svg" />
        : kind === "bill" ? <BillSvg b={item} /> : <CoinSvg c={item} />}
      {count > 0 && <span className="cash-count">x{count}</span>}
    </button>
  );
}

// counts: { [valor]: veces } para mostrar cuantas piezas se han tocado
export default function CashDenominations({ counts = {}, onPick }) {
  return (
    <div className="cash-wrap">
      <div className="cash-title">Billetes</div>
      <div className="cash-grid cash-grid--bills">
        {BILLS.map((b) => <Piece key={b.value} item={b} kind="bill" count={counts[b.value] || 0} onPick={onPick} />)}
      </div>
      <div className="cash-title">Monedas</div>
      <div className="cash-grid cash-grid--coins">
        {COINS.map((c) => <Piece key={c.value} item={c} kind="coin" count={counts[c.value] || 0} onPick={onPick} />)}
      </div>
    </div>
  );
}
